
    import {writable} from 'svelte/store'
    export const subscribers = writable(0)
    export const houseText = writable('start')
    export const animatedText = writable('paused')
    export const appPrimaryColor = 'rgb(255,80,35)'